import React from 'react';

import { Avatar, Space, Typography } from '@sravni/react-design-system';
import { checkIfMfo } from '@sravni/ugc/lib/utils/checkOrganizationsType';

import { ORGANIZATION_LIST, ORGANIZATION_LIST_MFO, PRODUCT_LIST } from '../../../../constants/routes';
import { findNameSettings } from '../../../../helpers/reviews';
import { createLinkProps } from '../../../../utils/routing';
import { TReviewCardProps } from '../../index';
import styles from '../../review-card.module.scss';

interface IReviewInfo extends Pick<TReviewCardProps, 'review' | 'tags' | 'type' | 'reviewTypes'> {
  isList: boolean;
  isMobile: boolean;
}

export const ReviewInfo: React.FC<IReviewInfo> = ({ reviewTypes, type, review, tags, isList, isMobile }) => {
  const serviceName = findNameSettings(tags, review.reviewTag);
  const isMfo = checkIfMfo(type);
  const listRoute = isMfo ? ORGANIZATION_LIST_MFO : ORGANIZATION_LIST;

  const tagAlias = tags.find(({ key }) => key === review.reviewTag)?.alias;

  const handleLogoClick = (e) => {
    e.preventDefault();

    const { as } = createLinkProps('/list', listRoute, {
      type: reviewTypes.itemTypeUrl,
      organization: review.alias,
    });

    document.location.href = `${as}/`;
  };

  const serviceLink = createLinkProps('/list', PRODUCT_LIST, {
    type: tagAlias,
  });

  return (
    <Space align={'start'} wrap={isMobile}>
      <Space align={'center'} justify={isMobile ? 'start' : 'end'} size={4} className={styles.space}>
        <Space
          align={'center'}
          justify={isMobile ? 'start' : 'end'}
          size={4}
          className={styles.organization}
          onClick={handleLogoClick}
        >
          {(review.logo?.square || review.logo?.round) && (
            <Avatar size={36} src={review.logo.square || review.logo.round || ''} className={styles.logo} />
          )}
          <Typography.Text size={14} strong className={'h-color-D100'}>
            {review.organizationName}
          </Typography.Text>
        </Space>
      </Space>
      {isList ? (
        <Typography.Link className={'h-color-D30 h-mr-16'} href={serviceLink.as}>
          {serviceName}
        </Typography.Link>
      ) : (
        <Typography.Text className={'h-color-D30 h-mr-16'}>{serviceName}</Typography.Text>
      )}
      {review.specificProductName && (
        <Typography.Text className={'h-color-D30'}>«{review.specificProductName}»</Typography.Text>
      )}
    </Space>
  );
};
